import React from 'react'
import { node } from 'prop-types'
import FilterButton from './buttons/FilterButton'
import { ReactComponent as TuneVariant } from '../assets/tune-variant.svg'
import { Box, Popover } from '@mui/material'

export default function FloatFilter({ children }) {
  const [anchorElFilter, setAnchorElFilter] = React.useState(null)

  const handleOpenFilterMenu = event => {
    setAnchorElFilter(event.currentTarget)
  }
  const handleCloseFilterMenu = () => {
    setAnchorElFilter(null)
  }

  return (
    <Box sx={{ flexGrow: 0, display: 'flex', maxWidth: '100px' }}>
      <FilterButton
        sx={{
          position: 'fixed !important',
          right: '0 !important',
          top: '25% !important',
          minWidth: '50px !important',
          height: '50px !important',
          background: 'rgba(200, 200, 200, 0.7) !important',
          borderRadius: '8px 0 0 8px !important',
          cursor: 'pointer !important'
        }}
        bg="#000000BF"
        Icon={TuneVariant}
        onClick={handleOpenFilterMenu}
      />
      <Popover
        sx={{
          mt: '45px',
          minWidth: '300px',
          '& .MuiPaper-elevation': {
            overflowY: 'inherit',
            overflowX: 'inherit',
            maxWidth: '360px'
          }
        }}
        id="menu-appbar"
        anchorEl={anchorElFilter}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={Boolean(anchorElFilter)}
        onClose={handleCloseFilterMenu}
      >
        <div
          style={{
            minWidth: '300px',
            padding: '0.5rem 0.75rem'
          }}
        >
          {children}
        </div>
      </Popover>
    </Box>
  )
}

FloatFilter.propTypes = {
  children: node
}
